import RecentRugsSegment from './RecentRugsSegment'
export default RecentRugsSegment
